export default "__VITE_ASSET__DDDH9FzG__"